<script lang="ts">
    import { Divider, TextButton } from '@allibee/components';
    import { ModalTermRevisionsPreview } from '$lib/service';

    import { MtmService } from '$lib/api';
    import { custom } from '$lib/utils';
    import { _ } from 'svelte-i18n';
    import { twMerge } from 'tailwind-merge';
    import { onMount } from 'svelte';

    // 개인정보 처리방침은 code 로 직접 조회한다.
    // 제목 매칭(예: "Agent 개인정보 처리방침")이나 SERVICE 목록 스캔에 의존하면 접두어·다국어·약관 타입에 따라 누락될 수 있다.
    let privacyTerm: MtmTermSimpleDto | undefined = undefined;
    let loading = true;

    onMount(async () => {
        try {
            const res = await MtmService.getTermByCode({ code: 'privacy-policy' });
            privacyTerm = res.data.data;
        } catch {
            // 약관 로드 실패 시 무시
        } finally {
            loading = false;
        }
    });
</script>

<footer class={twMerge('flex w-full items-center justify-center', $$props.class)}>
    <div class="font-regular flex items-center space-x-2">
        {#if !loading}
            {#if privacyTerm}
                <TextButton
                    class={`justify-start whitespace-pre-wrap text-pretty text-start text-sm font-normal text-gray-500`}
                    on:click={() => custom(ModalTermRevisionsPreview, { term: privacyTerm }, { size: 'lg', maxHeight: '80vh' })}
                >
                    {privacyTerm.title}
                </TextButton>
            {/if}
            <Divider direction="vertical" class="h-5 bg-gray-200" />
            <TextButton href="https://guide.allibee.ai/" target="_blank" class="text-sm font-normal text-gray-500">{$_('apps.contract.lib.service.helpDesk.FooterHelpDesk.userGuide')}</TextButton>
            <Divider direction="vertical" class="h-5 bg-gray-200" />
            <TextButton href="https://8kln6.channel.io/" target="_blank" class="text-sm font-normal text-gray-500">
                {$_('apps.contract.lib.service.helpDesk.FooterHelpDesk.customerCenter')}
            </TextButton>
        {/if}
    </div>
</footer>
